import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField, { type TextFieldProps } from '@mui/material/TextField';
import { useState, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export type PasswordFieldProps = Omit<TextFieldProps, 'type'>;

export function PasswordField(props: PasswordFieldProps): ReactElement {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(false);

    const toggleAdornment = (
        <InputAdornment position="end">
            <IconButton
                type="button"
                aria-label={visible ? t('ACTIONS.HIDE_PASSWORD') : t('ACTIONS.SHOW_PASSWORD')}
                onClick={() => setVisible((v) => !v)}
                edge="end"
                size="small">
                {visible ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </IconButton>
        </InputAdornment>
    );

    const inputSlot = props.slotProps?.input;

    return (
        <TextField
            {...props}
            type={visible ? 'text' : 'password'}
            slotProps={{
                ...props.slotProps,
                input: (ownerState) => {
                    const resolved = typeof inputSlot === 'function' ? inputSlot(ownerState) : inputSlot;
                    const existingEndAdornment = resolved?.endAdornment;
                    return {
                        ...resolved,
                        endAdornment:
                            existingEndAdornment != null ? (
                                <>
                                    {existingEndAdornment}
                                    {toggleAdornment}
                                </>
                            ) : (
                                toggleAdornment
                            ),
                    };
                },
            }}
        />
    );
}
